import React, { Fragment } from 'react';

const SurveyQuestion = (props) => {
    const { idx, question } = props;
    return (
        <Fragment>
            <div style={styles['question']}>
                <span style={styles['span']}>
                    <p style={styles['number']}>
                        <b>{`${idx + 1}.`}</b>
                    </p>
                    <span style={{ float: 'right' }}>
                        <b> Ref: </b>
                        <p style={{ display: 'inline-block', fontSize: '1.3rem', margin: 0 }}> {question.ref}</p>
                    </span>
                </span>
                <p style={styles['text']}>
                    {question.title}
                </p>
                <div style={styles['details']}>
                    <p><b>Type:</b> {question.type} </p>
                    {question.type === 'opinion_scale' &&
                        <Fragment>
                            <p><b>Start at one:</b> {` ${question.properties.start_at_one}`}</p>
                            <p><b>Number of steps:</b> {question.properties.steps}</p>
                        </Fragment>
                    }
                    {question.type === 'multiple_choice' &&
                        <Fragment>
                            <h4 style={{ marginBottom: 8 }}> Options: </h4>
                            <ol>
                                {question.properties.choices.map((option, idx) => {
                                    return (
                                        <li key={option.id} style={{ margin: 2 }}> {`${option.label}`} </li>
                                    )
                                })}
                            </ol>
                        </Fragment>
                    }
                    {props.question.type === 'group' &&
                        <Fragment>
                            <h4 style={{ marginBottom: 0 }}> Fields: </h4>
                            {props.question.properties.fields &&
                                <ol>
                                    {props.question.properties.fields.map((field, fieldIdx) => {
                                        return (
                                            <li type="a" key={field.ref} style={{ margin: 2 }}>
                                                <p style={{ fontSize: '1.1rem' }}>{` ${field.title}`}</p>
                                                <p><b>Ref: </b> {` ${field.ref}`}</p>
                                                <p><b>Type: </b> {` ${field.type}`}</p>
                                            </li>
                                        )
                                    })}
                                </ol>
                            }
                        </Fragment>
                    }
                    {question.validations &&
                        <p><b>Required:</b> {` ${question.validations.required}`}</p>
                    }
                </div>
            </div>
        </Fragment>
    )
};

const styles = {
    'question': {
        border: '1px solid black',
        width: '80%',
        margin: '3px',
        padding: 0,
        boxSizing: 'border-box'
    },
    'span': {
        boxSizing: 'border-box',
        width: '100%',
        display: 'inline-block',
        borderBottom: '1px solid',
        padding: '1rem'
    },
    'number': {
        fontSize: '1.3rem',
        float: 'left',
        margin: 0,
        lineHeight: '1'
    },
    'text': {
        margin: 0,
        padding: '1em',
        float: 'left',
        lineHeight: 1.4,
        fontSize: '1.2rem',
    },
    'details': {
        background: '#CCC',
        float: 'left',
        padding: '0 1em',
        width: '100%',
        boxSizing: 'border-box',
        display: 'inline-block',
    }
}

export default SurveyQuestion;